export default __webpack_public_path__ + "static/media/Favicon_large-removebg-preview.8238d064.png";